/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Flower(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle
        cx={128}
        cy={128}
        r={28}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M115.02821,103.18241C107.70283,87.77847,100,68.588,100,56a28,28,0,0,1,56,0c0,12.588-7.70285,31.7785-15.02823,47.18245"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M100.02144,126.8251c-17.00289-1.358-37.47372-4.28238-48.37527-10.57639a28,28,0,0,1,28-48.49742c10.90156,6.294,23.66957,22.56011,33.34708,36.606"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M112.99323,151.64269c-9.67751,14.04594-22.44551,30.312-33.34706,36.606a28,28,0,0,1-28-48.49742c10.90156-6.294,31.37241-9.21839,48.37532-10.5764"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M140.97179,152.81759C148.29717,168.22153,156,187.412,156,200a28,28,0,0,1-56,0c0-12.588,7.70285-31.7785,15.02823-47.18245"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M155.97856,129.1749c17.00289,1.358,37.47372,4.28238,48.37527,10.57639a28,28,0,0,1-28,48.49742c-10.90156-6.294-23.66957-22.56011-33.34708-36.606"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M143.00677,104.35731c9.67751-14.04594,22.44551-30.312,33.34706-36.606a28,28,0,0,1,28,48.49742c-10.90156,6.294-31.37241,9.21839-48.37532,10.5764"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default Flower;
